import { couponOptions } from "../Screen/redux/api/dummyJson";
import Select from "react-select";

const SelectBox = ({ selected, setSelected, options = couponOptions }) => {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "8px",
      borderColor: "#1A77BC",
      minHeight: "40px",
      fontSize: "14px",
    }),
  };
  return (
    <Select
      options={options}
      // placeholder={options == couponOptions ? "Region" : "Status"}
      placeholder={"Region"}
      isSearchable
      styles={customStyles}
      value={selected}
      onChange={(val) => setSelected(val)}
      isClearable
    />
  );
};

export default SelectBox;
